import { serviceNotifications } from "./serviceNotifications";
import { WSNotificationResponse } from "../../modules/Dashboard/components/Notifications";

export const patchViewNotification = async (
  id: string
): Promise<WSNotificationResponse> => {
  const { data } = await serviceNotifications.patch(`/in-app/${id}/view`);

  return data;
};
